import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { AllCombinedProductLines } from 'self-service-api/constants/AllCombinedProductLines';
import { ProductLevelAndProductLineToSuiteBOTranslationKeyMap, ProductLevelToSuiteBOHeaderTranslationKeyMap } from '../../constants/BusinessObjectivesTranslationKeys';
import ProductIcon from '../common/ProductIcon';
import SuiteBusinessObjectivesSubtext from '../merch-card/business-objectives/SuiteBusinessObjectivesSubtext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileSuiteBusinessObjectives = ({
  productLevel
}) => {
  const DisplayedProductLines = AllCombinedProductLines;
  return /*#__PURE__*/_jsxs(AccordionItem, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "merchCards.businessObjectives.seeDetails"
    }),
    children: [/*#__PURE__*/_jsx(View, {
      paddingBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: ProductLevelToSuiteBOHeaderTranslationKeyMap[productLevel]
      })
    }), DisplayedProductLines.map(localProductLine => {
      return /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        marginBlock: "100",
        children: [/*#__PURE__*/_jsx(ProductIcon, {
          name: localProductLine,
          iconStyle: {
            blockSize: '36px',
            marginInlineEnd: '300'
          }
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          justifyContent: "center",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: ProductLevelAndProductLineToSuiteBOTranslationKeyMap[productLevel][localProductLine].title
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(SuiteBusinessObjectivesSubtext, {
              productLevel: productLevel,
              productLine: localProductLine
            })
          })]
        })]
      }, localProductLine);
    })]
  });
};
export default MobileSuiteBusinessObjectives;